import { useState } from 'react';
import Loading from '../../../../components/Shared/Loader/Loading';
import { Card, CardBody, CardExpandToggler } from '../../../../components/card/card';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Pie from '../../../dashboard/Pie';
import Line from '../../../dashboard/Line';
import Bar from '../../../dashboard/Bar';
import { useTranslation } from 'react-i18next';

// const RaqeebDashboard = () => {
//   const [attendanceData] = useState({
//     series: [80, 10, 10], // الحضور, الغياب, التأخير
//     labels: ['حضور', 'غياب', 'تأخير'],
//   });

//   // بيانات التأخيرات اليومية
//   const [dailyDelays] = useState({
//     series: [
//       {
//         name: 'التأخير',
//         data: [10, 12, 5, 8, 15, 20, 7], // تأخيرات يومية
//       },
//     ],
//     categories: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
//   });

//   // بيانات الحضور الشهري
//   const [monthlyAttendance] = useState({
//     series: [
//       {
//         name: 'نسبة الحضور',
//         data: [90, 85, 80, 88, 92, 95, 87], // الحضور الشهري (٪)
//       },
//     ],
//     categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو'],
//   });

//   // 1. نسبة الإجازات المستخدمة والمتبقية
//   const [leaveData] = useState({
//     series: [60, 40], // مستخدم، متبقي
//     labels: ['إجازات مستهلكة', 'إجازات متبقية'],
//   });

//   // 2. اتجاهات الغياب السنوية
//   const [yearlyAbsence] = useState({
//     series: [
//       {
//         name: 'الغياب',
//         data: [5, 8, 6, 10, 12, 15, 20, 18, 10, 8, 6, 4], // شهري
//       },
//     ],
//     options: {
//       chart: {
//         type: 'area',
//       },
//       xaxis: {
//         categories: [
//           'يناير',
//           'فبراير',
//           'مارس',
//           'أبريل',
//           'مايو',
//           'يونيو',
//           'يوليو',
//           'أغسطس',
//           'سبتمبر',
//           'أكتوبر',
//           'نوفمبر',
//           'ديسمبر',
//         ],
//       },
//       colors: ['#dc3545'],
//     },
//   });

//   // 3. تصنيف الموظفين حسب الأداء
//   const [employeePerformance] = useState({
//     series: [
//       {
//         name: 'أداء الموظفين',
//         data: [90, 85, 80, 70, 65], // نسب الأداء
//       },
//     ],
//     options: {
//       chart: {
//         type: 'bar',
//       },
//       xaxis: {
//         categories: ['موظف 1', 'موظف 2', 'موظف 3', 'موظف 4', 'موظف 5'],
//       },
//       colors: ['#28a745'],
//       plotOptions: {
//         bar: {
//           horizontal: true,
//         },
//       },
//     },
//   });

//   // 4. مقارنة الحضور بين الأقسام
//   const [departmentAttendance] = useState({
//     series: [
//       {
//         name: 'حضور',
//         data: [80, 85, 90, 88], // القسم 1, 2, 3, 4
//       },
//       {
//         name: 'غياب',
//         data: [10, 8, 5, 7],
//       },
//       {
//         name: 'تأخير',
//         data: [10, 7, 5, 5],
//       },
//     ],
//     categories: ['القسم 1', 'القسم 2', 'القسم 3', 'القسم 4'],
//   });

//   return (
//     <div>
//       <Breadcrumb
//         BreadcrumbList={[
//           {
//             name: 'Home',
//             link: null,
//           },
//         ]}
//       />
//       <Loading loading={false} error={null}>
//         <div>
//           <div className="row g-3">
//             {/* نسبة الحضور والغياب */}
//             <div className="col-lg-4">
//               <Card className="mb-3" style={{ height: '100%' }}>
//                 <CardBody className="">
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 fs-6 fw-bold">نسبة الحضــور</span>
//                     <CardExpandToggler />
//                   </div>
//                   <div className="">
//                     <Pie
//                       labels={attendanceData.labels}
//                       series={attendanceData.series}
//                       height={400}
//                     />
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-lg-8">
//               <Card className="mb-3" style={{ height: '100%' }}>
//                 <CardBody className="">
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 fs-6 fw-bold">التأخيرات اليومية</span>
//                     <CardExpandToggler />
//                   </div>
//                   <div className="">
//                     <Line categories={dailyDelays.categories} series={dailyDelays.series} />
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-lg-6">
//               <Card className="mb-3" style={{ height: '100%' }}>
//                 <CardBody className="">
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 fs-6 fw-bold">الحضور الشهري</span>
//                     <CardExpandToggler />
//                   </div>
//                   <div className="">
//                     <Bar
//                       categories={monthlyAttendance.categories}
//                       series={monthlyAttendance.series}
//                       height={400}
//                     />
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-lg-6">
//               <Card className="mb-3" style={{ height: '100%' }}>
//                 <CardBody className="">
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 fs-6 fw-bold">مقارنة الحضور بين الأقسام</span>
//                     <CardExpandToggler />
//                   </div>
//                   <div className="">
//                     <Bar
//                       categories={departmentAttendance.categories}
//                       series={departmentAttendance.series}
//                       height={400}
//                       isStacked
//                     />
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>
//           </div>
//         </div>
//       </Loading>
//     </div>
//   );
// };

// export default RaqeebDashboard;




const RaqeebDashboard = () => {
  const { t, i18n } = useTranslation();

  const [attendanceData] = useState({
    series: [80, 10, 10], // الحضور, الغياب, التأخير
    labels: i18n.language === 'en' ? ['Present', 'Absent', 'Late'] : ['حضور', 'غياب', 'تأخير'],
  });

  // بيانات التأخيرات اليومية
  const [dailyDelays] = useState({
    series: [
      {
        name: i18n.language === 'en' ? 'Delays' : 'التأخير',
        data: [10, 12, 5, 8, 15, 20, 7], // تأخيرات يومية
      },
    ],
    categories: i18n.language === 'en'
      ? ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      : ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
  });

  // بيانات الحضور الشهري
  const [monthlyAttendance] = useState({
    series: [
      {
        name: i18n.language === 'en' ? 'Attendance Rate' : 'نسبة الحضور',
        data: [90, 85, 80, 88, 92, 95, 87], // الحضور الشهري (٪)
      },
    ],
    categories: i18n.language === 'en'
      ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul']
      : ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو'],
  });

  // 1. نسبة الإجازات المستخدمة والمتبقية
  const [leaveData] = useState({
    series: [60, 40], // مستخدم، متبقي
    labels: i18n.language === 'en' ? ['Used Leaves', 'Remaining Leaves'] : ['إجازات مستهلكة', 'إجازات متبقية'],
  });

  // 2. اتجاهات الغياب السنوية
  const [yearlyAbsence] = useState({
    series: [
      {
        name: i18n.language === 'en' ? 'Absence' : 'الغياب',
        data: [5, 8, 6, 10, 12, 15, 20, 18, 10, 8, 6, 4], // شهري
      },
    ],
    options: {
      chart: {
        type: 'area',
      },
      xaxis: {
        categories: i18n.language === 'en'
          ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
          : ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
      },
      colors: ['#dc3545'],
    },
  });

  // 3. تصنيف الموظفين حسب الأداء
  const [employeePerformance] = useState({
    series: [
      {
        name: i18n.language === 'en' ? 'Employee Performance' : 'أداء الموظفين',
        data: [90, 85, 80, 70, 65], // نسب الأداء
      },
    ],
    options: {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: i18n.language === 'en'
          ? ['Employee 1', 'Employee 2', 'Employee 3', 'Employee 4', 'Employee 5']
          : ['موظف 1', 'موظف 2', 'موظف 3', 'موظف 4', 'موظف 5'],
      },
      colors: ['#28a745'],
      plotOptions: {
        bar: {
          horizontal: true,
        },
      },
    },
  });

  // 4. مقارنة الحضور بين الأقسام
  const [departmentAttendance] = useState({
    series: [
      {
        name: i18n.language === 'en' ? 'Attendance' : 'حضور',
        data: [80, 85, 90, 88], // القسم 1, 2, 3, 4
      },
      {
        name: i18n.language === 'en' ? 'Absence' : 'غياب',
        data: [10, 8, 5, 7],
      },
      {
        name: i18n.language === 'en' ? 'Late' : 'تأخير',
        data: [10, 7, 5, 5],
      },
    ],
    categories: i18n.language === 'en'
      ? ['Dept 1', 'Dept 2', 'Dept 3', 'Dept 4']
      : ['القسم 1', 'القسم 2', 'القسم 3', 'القسم 4'],
  });

  return (
    <div>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: i18n.language === 'en' ? 'Home' : 'الرئيسية',
            link: null,
          },
        ]}
      />
      <Loading loading={false} error={null}>
        <div>
          <div className="row g-3">
            {/* نسبة الحضور والغياب */}
            <div className="col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody className="">
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">
                      {i18n.language === 'en' ? 'Attendance Rate' : 'نسبة الحضــور'}
                    </span>
                    <CardExpandToggler />
                  </div>
                  <div className="">
                    <Pie
                      labels={attendanceData.labels}
                      series={attendanceData.series}
                      height={400}
                    />
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-lg-8">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody className="">
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">
                      {i18n.language === 'en' ? 'Daily Delays' : 'التأخيرات اليومية'}
                    </span>
                    <CardExpandToggler />
                  </div>
                  <div className="">
                    <Line categories={dailyDelays.categories} series={dailyDelays.series} />
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-lg-6">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody className="">
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">
                      {i18n.language === 'en' ? 'Monthly Attendance' : 'الحضور الشهري'}
                    </span>
                    <CardExpandToggler />
                  </div>
                  <div className="">
                    <Bar
                      categories={monthlyAttendance.categories}
                      series={monthlyAttendance.series}
                      height={400}
                    />
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-lg-6">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody className="">
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">
                      {i18n.language === 'en' ? 'Attendance by Department' : 'مقارنة الحضور بين الأقسام'}
                    </span>
                    <CardExpandToggler />
                  </div>
                  <div className="">
                    <Bar
                      categories={departmentAttendance.categories}
                      series={departmentAttendance.series}
                      height={400}
                      isStacked
                    />
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </Loading>
    </div>
  );
};

export default RaqeebDashboard;
